import React from 'react';
import numeral from 'numeral';
import BiddingItemSC from './bidding-item.styled';
import { BodyText } from '../../typography';
import Button from '../../ui/button';
import Mark from '../../ui/mark';
import { formatDayCount, getColorByStatus } from '../../../utils/helpers';
import dlt from '../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as ClockIcon } from '../../../assets/img/svg/small-clock.svg';
import { ReactComponent as CheckIcon } from '../../../assets/img/svg/small-check.svg';
import { ReactComponent as CrossIcon } from '../../../assets/img/svg/small-cross.svg';

const BiddingItem = ({
  wmNumber,
  amountForSale,
  buyerLastBid,
  sellerLastBid,
  showButtons,
  status,
  timeRemaining,
  isTablet,
  onBuyClick,
  onBidClick,
  onCancelClick,
  hasPagination,
  lastBidder,
}) => {
  return (
    <BiddingItemSC hasPagination={hasPagination}>
      {isTablet ? (
        <>
          <td>
            <BodyText className="bolder">{wmNumber}</BodyText>
            <BodyText>{numeral(amountForSale).format('0,00.00')} €</BodyText>
          </td>
          <td>
            <BodyText
              className={
                buyerLastBid && lastBidder === 'b'
                  ? 'bolder green'
                  : buyerLastBid
                  ? 'bolder'
                  : 'bolder black-transparent-lighter'
              }
            >
              {buyerLastBid ? numeral(buyerLastBid).format('0,00.00') : '--'} €
            </BodyText>
            <BodyText
              className={
                sellerLastBid && lastBidder === 's'
                  ? 'bolder green'
                  : sellerLastBid
                  ? 'bolder'
                  : 'bolder black-transparent-lightest'
              }
            >
              {sellerLastBid ? numeral(sellerLastBid).format('0,00.00') : '--'} €
            </BodyText>
          </td>
        </>
      ) : (
        <>
          <td>
            <BodyText className="bolder">{wmNumber}</BodyText>
          </td>
          <td>
            <BodyText>{numeral(amountForSale).format('0,00.00')} €</BodyText>
          </td>
          <td>
            <BodyText
              className={
                sellerLastBid && lastBidder === 's'
                  ? 'bolder green'
                  : sellerLastBid
                  ? 'bolder'
                  : 'bolder black-transparent-lightest'
              }
            >
              {sellerLastBid ? numeral(sellerLastBid).format('0,00.00') : '--'} €
            </BodyText>
          </td>
          <td>
            <BodyText
              className={
                buyerLastBid && lastBidder === 'b'
                  ? 'bolder green'
                  : buyerLastBid
                  ? 'bolder'
                  : 'bolder black-transparent-lighter'
              }
            >
              {buyerLastBid ? numeral(buyerLastBid).format('0,00.00') : '--'} €
            </BodyText>
          </td>
        </>
      )}
      <td>
        {!showButtons ? (
          <>
            {timeRemaining !== null ? (
              <Mark>
                <span className="table-cell-status bold">
                  <ClockIcon />
                  <FormattedMessage
                    id="investor_bidding_table_item_awaits_response"
                    defaultMessage={dlt['investor_bidding_table_item_awaits_response']}
                  />{' '}
                  (<FormattedMessage id="global_remains" defaultMessage={dlt['global_remains']} />{' '}
                  {timeRemaining}{' '}
                  <FormattedMessage
                    id={formatDayCount(timeRemaining)}
                    defaultMessage={dlt[`${formatDayCount(timeRemaining)}`]}
                  />
                  )
                </span>
              </Mark>
            ) : !timeRemaining && status ? (
              <Mark colorStyle={getColorByStatus(status)}>
                <span className="table-cell-status bold">
                  {getColorByStatus(status) === 'GREEN' ? (
                    <CheckIcon />
                  ) : getColorByStatus(status) === 'RED' ? (
                    <CrossIcon />
                  ) : getColorByStatus(status) === 'ORANGE' ? (
                    <ClockIcon />
                  ) : null}
                  <FormattedMessage
                    id={`investor_bidding_status_${status}`}
                    defaultMessage={dlt[`investor_bidding_status_${status}`]}
                  />
                </span>
              </Mark>
            ) : null}
          </>
        ) : (
          <>
            <Button
              type="PRIMARY"
              className="buy-button"
              size="MEDIUM"
              onClick={(event) => onBuyClick(event)}
            >
              <FormattedMessage id="global_buy_simple" defaultMessage={dlt['global_buy_simple']} />
            </Button>
            <Button
              type="OUTLINED"
              className="bid-button"
              size="MEDIUM"
              onClick={(event) => onBidClick(event)}
            >
              <FormattedMessage id="global_bid" defaultMessage={dlt['global_bid']} />
            </Button>
            <Button
              type="OUTLINED"
              className="cancel-button"
              size="MEDIUM"
              onClick={(event) => onCancelClick(event)}
            >
              <FormattedMessage id="global_refuse" defaultMessage={dlt['global_refuse']} />
            </Button>
          </>
        )}
      </td>
    </BiddingItemSC>
  );
};

export default BiddingItem;
